<template>
  <input
    ref="checkbox"
    type="checkbox"
    class="ag-checkbox-input"
    :checked="isAllSelected"
    :disabled="isDisabled"
    @change="handleSelectAll"
  />
</template>

<script>
import Vue from 'vue';
import get from 'lodash/get';

export default Vue.extend({
  name: 'TsgScopedHeaderCheckbox',

  data() {
    return {
      isAllSelected: false,
      isIndeterminate: false,
    };
  },

  computed: {
    parent() {
      return get(this.params, 'context.componentParent');
    },

    colId() {
      if (!this.params || !this.parent) return null;

      // Use column ID directly as the registration key
      // Grouped mode: "toolStoreGroups.tsg1.selection"
      // Non-grouped mode: "selection"
      return get(this.params, 'column.colId', null);
    },

    isDisabled() {
      // Read disabled state from params (computed by parent via isSelectionDisabled)
      return get(this.params, 'disabled', false);
    },
  },

  mounted() {
    if (!this.params || !this.parent) return;

    this.updateState();

    // Store reference for parent to update
    if (!this.parent.tsgHeaderCheckboxRefs) {
      this.parent.tsgHeaderCheckboxRefs = {};
    }
    const key = this.colId;
    if (key) {
      this.parent.tsgHeaderCheckboxRefs[key] = this;
    }
  },

  methods: {
    handleSelectAll(event) {
      // Short-circuit if disabled
      if (this.isDisabled) return;

      if (!this.parent || !this.colId) return;
      this.parent.toggleSelectAllForTsg(this.colId, event.target.checked);
    },

    updateState() {
      if (!get(this.parent, 'gridApi') || !this.colId) return;

      // Extract TSG key from colId for grouped mode
      let targetTsgKey = null;
      if (this.parent.isGroupTSGsEnabled && this.colId) {
        targetTsgKey = this.parent.getTsgKeyFromColId(this.colId);
      }

      let totalVisible = 0;
      let selectedVisible = 0;

      this.parent.gridApi.forEachNodeAfterFilter(node => {
        if (!node.data || !node.data.productKey) return;

        const selectionTsgKey = this.parent.isGroupTSGsEnabled
          ? targetTsgKey
          : this.parent.getNodeTsgKey(node);
        if (!selectionTsgKey) return;

        totalVisible += 1;
        const selections = this.parent.selectedRowsByTsg[selectionTsgKey];
        if (selections && selections.has(node.data.productKey)) {
          selectedVisible += 1;
        }
      });

      this.isAllSelected = totalVisible > 0 && selectedVisible === totalVisible;
      this.isIndeterminate = selectedVisible > 0 && selectedVisible < totalVisible;

      // Set indeterminate on the actual DOM element (can't be done via Vue binding)
      this.$nextTick(() => {
        if (this.$refs.checkbox) {
          this.$refs.checkbox.indeterminate = this.isIndeterminate;
        }
      });
    },
  },
});
</script>
